// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
export interface OfferType {
    description: string;
    offerSku: string;
    name: string;
    virtualSku: string;
}

export interface ShippingOfferType {
    offerSku: string;
    symptomCode?: string;
    accessorySku?: string;
    title: string;
    offers: OfferType[];
}

export const INITIAL_STATE: {
    shippingOffers: ShippingOfferType[];
} = { shippingOffers: [] };

export type ShippingShippingStoreType = Readonly<typeof INITIAL_STATE>;

export function _getDeviceShippingOfferData(
    state: any,
    { payload }: { payload: any }
): any {
    if (payload) {
        return {
            ...state,
            deviceShippingOffers: payload,
        };
    }
    return state;
}

export function _getAccessoryShippingOfferData(
    state: any,
    { payload }: { payload: any }
): any {
    if (payload) {
        return {
            ...state,
            accessoryShippingOffers: payload,
        };
    }
    return state;
}
